export class Aquifere {
    constructor(
        public code?: string,
        public nature?:string,
        public nom?:string,
        public niveau?:string
    ) {

    }
}